module.exports = __webpack_public_path__ + "static/media/chef.6127fc1c.svg";